<template></template>

<script>
  import env from '@/lib/env'
  import { chrome } from 'window'
  import * as Sentry from '@sentry/browser'
  import * as Notifications from './notifications'

  export default {
    props: ['version'],
    created () {
      chrome.runtime.sendMessage(env('EXTENSION_ID'), {
        type: 'JIMINNY.EXTENSION.GET_VERSION'
      }, (response) => {
        const installedVersion = parseInt(response.replace(/\./g, ''), 10)
        const minVersion = parseInt(this.version.replace(/\./g, ''), 10)

        if (installedVersion < minVersion) {
          Notifications.staleExtensionNotification().show()

          Sentry.withScope(scope => {
            scope.setExtras({
              debug: false,
              installedVersion
            })
            Sentry.captureMessage('Old Jiminny Extension')
          })
        }
      })
    }
  }
</script>



// WEBPACK FOOTER //
// extension-version-checker.vue?20a0f604